import { DefaultSeoProps } from 'next-seo'
import { DEFAULT_DESCRIPTION } from './src/config/constants/meta'
import { OG_HEIGHT, OG_WIDTH, ogImageUrl } from './src/config/constants/seo'

// The fallback for every page without its own entry in config/constants/meta.ts. A page's own tags replace these (same keys).
export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | CADINUdex',
  defaultTitle: 'CADINUdex',
  description: DEFAULT_DESCRIPTION,
  twitter: {
    cardType: 'summary_large_image',
    handle: '@Cadinu',
    site: '@Cadinu',
  },
  openGraph: {
    type: 'website',
    siteName: 'CADINUdex',
    title: 'CADINUdex: swap, earn and compete on BNB Chain',
    description: DEFAULT_DESCRIPTION,
    images: [{ url: ogImageUrl('home'), width: OG_WIDTH, height: OG_HEIGHT, alt: 'CADINUdex', type: 'image/jpeg' }],
  },
}
